import { DadosComercial } from './Comercial'
import { DadosConstrucao } from './Construcao'
import { DadosCompraTerreno } from './DadosCompraTerreno'
import { DadosDetalhamentoProjeto } from './DadosDetalhamentoProjeto'
import { DadosGerais } from './DadosGerais'
import { TipoSituacaoEnum } from './Enum/TipoSituacaoEnum'
import { DadosInfraestrutura } from './Infraestrutura'
import { DadosLoteadora } from './Loteadora'
import { DadosUrbanizacao } from './Urbanizacao'
import { Guid } from 'guid-typescript'

export type CasasEntrada = {
  idTerreno: string
  dadosGerais: DadosGerais
  dadosCompraTerreno: DadosCompraTerreno
  detalhamentoProjeto: DadosDetalhamentoProjeto
  infraestrutura: DadosInfraestrutura
  loteadora: DadosLoteadora
  comercial: DadosComercial
  construcao: DadosConstrucao
  urbanizacao: DadosUrbanizacao
  situacaoViabilidade?: TipoSituacaoEnum
  id?: Guid
  fase: number
  idEmpreendimento?: Guid
}

export const mapearCasasEntrada = (
  idTerreno: string,
  dadosGerais: DadosGerais,
  dadosCompraTerreno: DadosCompraTerreno,
  detalhamentoProjeto: DadosDetalhamentoProjeto,
  infraestrutura: DadosInfraestrutura,
  loteadora: DadosLoteadora,
  comercial: DadosComercial,
  construcao: DadosConstrucao,
  urbanizacao: DadosUrbanizacao,
  fase: number,
  situacaoViabilidade?: TipoSituacaoEnum,
  id?: Guid,
  idEmpreendimento?: Guid
): CasasEntrada => {
  return {
    idTerreno: idTerreno,
    dadosGerais: dadosGerais,
    dadosCompraTerreno: dadosCompraTerreno,
    detalhamentoProjeto: detalhamentoProjeto,
    infraestrutura: infraestrutura,
    loteadora: loteadora,
    comercial: comercial,
    construcao: construcao,
    urbanizacao: { ...urbanizacao, itensUrbanizacao: urbanizacao.itensUrbanizacao.filter((urbanizacao) => urbanizacao.descricao || urbanizacao.valor) },
    situacaoViabilidade: situacaoViabilidade,
    id: id,
    fase: fase,
    idEmpreendimento: idEmpreendimento
  }
}
